import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAlert } from 'react-alert';
import { setSpinner } from 'services/store/actions/view';
import {
  getStorageOrderById,
  completeStorageOrder,
  sendStorageOrder,
  downloadStorageOrderPdf,
} from 'services/apiRequests/storage.api';

export const useStorageOrderDetail = (orderId) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const alert = useAlert();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [showSendModal, setShowSendModal] = useState(false);

  useEffect(() => {
    fetchOrderDetails();
  }, [orderId]);

  const fetchOrderDetails = async () => {
    setLoading(true);
    dispatch(setSpinner(true));

    try {
      const response = await getStorageOrderById(orderId);
      setOrder(response.order);
    } catch (error) {
      console.error('Error fetching order details:', error);
      alert.error('Błąd pobierania szczegółów zamówienia');
      history.push('/storage');
    } finally {
      setLoading(false);
      dispatch(setSpinner(false));
    }
  };

  const handleCompleteOrder = async () => {
    dispatch(setSpinner(true));
    try {
      await completeStorageOrder(orderId);
      alert.success('Zamówienie zostało zrealizowane');
      fetchOrderDetails(); // Odśwież dane
      setShowCompleteModal(false);
    } catch (error) {
      console.error('Error completing order:', error);
      alert.error('Błąd realizacji zamówienia');
    } finally {
      dispatch(setSpinner(false));
    }
  };

  const handleSendOrder = async () => {
    dispatch(setSpinner(true));
    try {
      await sendStorageOrder(orderId);
      alert.success('Zamówienie zostało wysłane do realizacji');
      fetchOrderDetails(); // Odśwież dane
      setShowSendModal(false);
    } catch (error) {
      console.error('Error sending order:', error);
      alert.error('Błąd wysyłania zamówienia');
    } finally {
      dispatch(setSpinner(false));
    }
  };

  const handleDownloadPdf = async () => {
    try {
      dispatch(setSpinner(true));
      await downloadStorageOrderPdf(orderId, order?.number || 'err');
      alert.success('Plik PDF został pobrany');
    } catch (error) {
      console.error('Error downloading PDF:', error);
      alert.error('Błąd pobierania pliku PDF');
    } finally {
      dispatch(setSpinner(false));
    }
  };

  const handleBack = () => {
    history.push('/storage');
  };

  return {
    order,
    loading,
    handleCompleteOrder,
    handleSendOrder,
    handleDownloadPdf,
    handleBack,
    fetchOrderDetails,
    showCompleteModal,
    setShowCompleteModal,
    showSendModal,
    setShowSendModal,
  };
};
